import RoleAndCookieModal from "@/role_and_cookie_modal/components/role_and_cookie_modal"
import componentShell from "./shell"

export default componentShell(RoleAndCookieModal)
